import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Sparkles, CreditCard, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SubscriptionBanner() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/subscription/status").then(r => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return null;

  const subscribe = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout");
      setBusy(false);
    }
  };

  if (s.in_paid) {
    return (
      <div data-testid="sub-banner-active" className="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 text-sm flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-100 flex items-center justify-center">
            <Sparkles className="text-emerald-600" size={16} strokeWidth={2.5}/>
          </div>
          <div>
            <div className="font-black text-emerald-900">Subscription active</div>
            <div className="text-xs text-emerald-700">{s.days_left} days remaining · renews automatically</div>
          </div>
        </div>
      </div>
    );
  }

  if (s.in_trial) {
    return (
      <div data-testid="sub-banner-trial" className="bg-amber-50 border border-amber-200 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-amber-100 flex items-center justify-center">
            <Sparkles className="text-amber-700" size={16} strokeWidth={2.5}/>
          </div>
          <div>
            <div className="font-black text-amber-900">Free trial · {s.days_left} {s.days_left === 1 ? "day" : "days"} left</div>
            <div className="text-xs text-amber-800">Subscribe now to keep learning after your trial ends — ${s.price_usd}/month</div>
          </div>
        </div>
        <Button data-testid="sub-banner-subscribe" onClick={subscribe} disabled={busy}
                className="rounded-full bg-amber-500 hover:bg-amber-600 text-white font-bold h-10 px-5 whitespace-nowrap">
          {busy ? <Loader2 size={14} className="animate-spin"/> : <><CreditCard size={14} strokeWidth={2.5} className="mr-2"/>Subscribe ${s.price_usd}/mo</>}
        </Button>
      </div>
    );
  }

  return (
    <div data-testid="sub-banner-expired" className="bg-rose-50 border border-rose-200 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-rose-100 flex items-center justify-center">
          <Sparkles className="text-rose-600" size={16} strokeWidth={2.5}/>
        </div>
        <div>
          <div className="font-black text-rose-900">Trial ended</div>
          <div className="text-xs text-rose-800">Subscribe to continue lessons — ${s.price_usd}/month</div>
        </div>
      </div>
      <Button data-testid="sub-banner-subscribe" onClick={subscribe} disabled={busy}
              className="rounded-full bg-rose-500 hover:bg-rose-600 text-white font-bold h-10 px-5 whitespace-nowrap">
        {busy ? <Loader2 size={14} className="animate-spin"/> : <><CreditCard size={14} strokeWidth={2.5} className="mr-2"/>Subscribe ${s.price_usd}/mo</>}
      </Button>
    </div>
  );
}
